module.exports = __webpack_public_path__ + "img/sixpackcarrier77.b598c4f4.jpg";